import { useRoutes } from 'react-router-dom';

// routes
// import MainRoutes from './MainRoutes';
import PrimaryRoutes from './PrimaryRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([AuthenticationRoutes, PrimaryRoutes]);
}
